import { ContentStateInterface, InsertionIdentification } from '../../../../../@types/types'
import { FlowInformation } from '../../../../../@types/flow-types'
import { metaInformationToApi } from './metaInformation/metaInformationToApi'
import { addressToApi } from './address/addressToApi'
import { locationToApi } from './location/locationToApi'
import { priceToApiRent } from './price/priceToApi'
import { detailsToApi } from './details/detailsToApi'
import { informationToApi } from './information/informationToApi'
import { additionalInformationToApi } from './additionalInformation/additionalInformationToApi'
import { tenantDocumentsToApi } from './tenantDocuments/tenantDocumentsToApi'
import { contactToApi } from './contact/contactToApi'
import { RealEstate } from '../../../../../@types/real-estate-api-types'
import { otherCostsToApi } from './otherCosts/otherCostsToApi'
import { AddressFeatureState } from '../../../../../@types/state-types'
import { noCourtageInformationToApi } from './courtageInformation/courtageInformationToApi'
import { BuildingTypeOption } from '../../../../../@types/dropdown-types'
import { noApiSearchDataToApi } from './apiSearchData/apiSearchDataToApi'

export const estateToApi = (
  ident: InsertionIdentification,
  insertionData: ContentStateInterface,
  addressFeature: AddressFeatureState,
  flowInformation: FlowInformation
): RealEstate => ({
  id: ident.id,
  unitId: ident.unitId,
  buildingId: ident.buildingId,
  externalId: insertionData.externalId,
  published: insertionData.published,
  state: ident.progressState,
  realEstateId: ident.realEstateId,
  returnUrl: '',
  context: '',
  creationDate: new Date().toISOString(),
  title: String(insertionData.adTitle),
  buildingType: insertionData.buildingType?.value ?? BuildingTypeOption.NO_INFORMATION,
  metaInformation: metaInformationToApi(ident),
  address: addressToApi(insertionData, addressFeature),
  location: locationToApi(insertionData),
  price: (flowInformation.priceToApiMapper ?? priceToApiRent)(insertionData),
  otherCosts: otherCostsToApi(insertionData),
  details: detailsToApi(insertionData),
  information: informationToApi(insertionData),
  additionalInformation: additionalInformationToApi(insertionData),
  tenantDocuments: tenantDocumentsToApi(insertionData),
  contact: contactToApi(insertionData),
  ...flowInformation.metaData,
  apiSearchData: (flowInformation.apiSearchDataToApiMapper ?? noApiSearchDataToApi)(insertionData),
  courtageInformation:
    insertionData.courtage || insertionData.courtageNote || insertionData.hasCourtage !== undefined
      ? (flowInformation.courtageToApiMapper ?? noCourtageInformationToApi)(insertionData)
      : undefined,
  conversionToLeadAllowed: insertionData.conversionToLeadAllowed ?? false,
  groupNumber: insertionData.groupNumber,
})
